import {
  EditMode,
  Routes,
  SiteContentLoader,
  ToastProvider,
  TranslationLoader,
  UserProfileLoader,
} from '@components';
import { useEditMode, useTheme } from '@hooks';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { AppDispatch } from '@store';
import { getBrowserLocation } from '@store/location/location.slice';
import { GlobalStyles } from '@themes/global/GlobalStyles';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import './index.css';

function App() {
  const { currentTheme } = useTheme();
  const { inBlockEdit } = useEditMode();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getBrowserLocation());
  }, [dispatch]);

  return (
    <Box className='app'>
      <ThemeProvider theme={currentTheme}>
        <GlobalStyles className='app-global-container'>
          <UserProfileLoader />
          <HelmetProvider>
            <TranslationLoader>
              <CssBaseline />
              {!inBlockEdit && (
                <SiteContentLoader>
                  <Routes />
                </SiteContentLoader>
              )}
            </TranslationLoader>
            <EditMode />
            <ToastProvider />
          </HelmetProvider>
        </GlobalStyles>
      </ThemeProvider>
    </Box>
  );
}

export default App;
